import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests'

export const mockGetPaymentDetailsIframeUrlSuccess = (
  externalId: string,
  url = 'www.example.com/iframe'
) => {
  return http.post(
    `/api/v3/pay/cards/${externalId}/sensitive-card-details-iframe-url/`,
    () => {
      return HttpResponse.json(getResponseObject({ url }), { status: 200 })
    },
    { once: true }
  )
}

export const mockGetPaymentDetailsIframeUrlError = (
  externalId: string,
  errorStatusCode = 400,
  scaSessionCode = 'sca_session_code_12345'
) => {
  return http.post(
    `/api/v3/pay/cards/${externalId}/sensitive-card-details-iframe-url/`,
    () => {
      if (errorStatusCode === 403) {
        return new HttpResponse(null, {
          status: 403,
          headers: { 'x-sca-session-code': scaSessionCode },
        })
      }
      return new HttpResponse(null, { status: errorStatusCode })
    },
    { once: true }
  )
}
